const { useState, useEffect, useCallback } = require("react");

const openFullscreen = () => {
  if (document.fullscreenElement === null) {
    document.documentElement.requestFullscreen();
  }
};

const closeFullscreen = () => {
  if (document.fullscreenElement !== null) {
    document.exitFullscreen();
  }
};

const isFullscreen = () => {
  return document.fullscreenElement !== null;
};

const useFullscreen = (el = document.documentElement) => {
  const [fullscreen, setFullscreen] = useState(() => {
    return isFullscreen();
  });

  useEffect(() => {
    const handleChange = () => {
      if (isFullscreen()) {
        setFullscreen(true);
      } else {
        setFullscreen(false);
      }
    };

    const handleKeyDown = (e) => {
      if(e.key === 'F11') {
        e.preventDefault();
      }
    };
    
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('fullscreenchange', handleChange);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('fullscreenchange', handleChange);
    };
  }, []);

  const toggle = useCallback(() => {
    if (fullscreen) {
      closeFullscreen();
    } else {
      openFullscreen(el);
    }

  }, [fullscreen, el]);

  return {
    isFullscreen: fullscreen,
    toggle,
  };
};

export default useFullscreen;
